
// WebpackRequireFrom
typeof __webpack_require__ !== "undefined" && Object.defineProperty(__webpack_require__, "p", {
  get: function () {
try {
  if (typeof __bundle_url__ !== "string") {
    throw new Error("WebpackRequireFrom: '__bundle_url__' is not a string or not available at runtime. See https://github.com/agoldis/webpack-require-from#troubleshooting");
  }
  return __bundle_url__;
} catch (e) {
  if (!false) {
    console.error(e);
  }
  return "/bundle/";
}
 },
  set: function (newPublicPath) {
    console.warn("WebpackRequireFrom: something is trying to override webpack public path. Ignoring the new value" + newPublicPath  + ".");
}
});